import ListaFichajesEmpleadoImpl from 'components/fichajes/ListaFichajesEmpleadoImpl'
import React from 'react'
import { Card, Col, Row } from 'reactstrap'

const ViewEmpleadoConsultar = () => {
  return (
    <>
        <Row>
            <Col>
                <Card>

                <ListaFichajesEmpleadoImpl></ListaFichajesEmpleadoImpl>
                </Card>
            </Col>
        </Row>
    </>
  )
}

export default ViewEmpleadoConsultar